// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "price-1WKvY";
var _3 = "charge-2PmFe";
var _4 = "total-2qsl1";
var _5 = "header__name-3T3nl";
var _6 = "taxesTooltip-2ggNU";
var _7 = "flight-f4929";
export { _1 as "__esModule", _2 as "price", _3 as "charge", _4 as "total", _5 as "header__name", _6 as "taxesTooltip", _7 as "flight" }
export default { "__esModule": _1, "price": _2, "charge": _3, "total": _4, "header__name": _5, "taxesTooltip": _6, "flight": _7 }
